import { filterParamMapping } from '../common/mappings';
import * as qs from 'qs';
import { trimAndAddAsterisk } from '../../utility/QueryUtility';

export const standardQuerySerializer = (params: any) => {
  return qs.stringify(params, { encode: true, arrayFormat: 'comma' });
};

/**
 * Builds a params serializer that runs `params` through a chain of transform
 * callbacks and then `qs.stringify`s the result. Relocated from the deprecated
 * `utils/serviceUtils` as part of the ServiceHandler consolidation.
 */
export function transformParams(callbacks: any[] = [], stringifyOptions = {}) {
  return (params: any) => {
    const nextParams = callbacks.reduce((acc, callback) => {
      return callback(acc);
    }, params);

    return qs.stringify(nextParams, stringifyOptions);
  };
}

export const standardParamSerializer = [
  { path: 'page' },
  { path: 'size' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'modified':
          case 'created':
          case 'retainedDate':
            return `${orderBy},${order}`;
          default:
            return `${orderBy}.keyword,${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  filterParamMapping,
  { path: 'searchAfter' },
  { path: 'pageRequested' },
  { path: 'docIds', paramKey: 'id.keyword' },
];
